import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory, EntityDataService } from '@ngrx/data';
import { KE_DATA_SOURCES_LIST_ENTITY_NAME } from '@selfai-platform/store';
import { DataSource } from '../model';
import { DataSourcesDataService } from './data-sources-data.service';

@Injectable({ providedIn: 'root' })
export class DataSourceStore extends EntityCollectionServiceBase<DataSource> {
  constructor(
    public entityDataService: EntityDataService,
    public dataSourcesService: DataSourcesDataService,
    public serviceElementsFactory: EntityCollectionServiceElementsFactory,
  ) {
    entityDataService.registerService(KE_DATA_SOURCES_LIST_ENTITY_NAME, dataSourcesService);
    super(KE_DATA_SOURCES_LIST_ENTITY_NAME, serviceElementsFactory);
  }
}
